import React, { useState } from "react";
import Logo from "../../assets/logo.png";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import { NavbarList } from "./NavbarList";
import { NavbarListMobile } from "./NavbarListMobile";
import { NavbarSocialComponent } from "./NavbarSocialComponent";

export const Navbar = () => {
  const [toggleNavbar, setToggleNavbar] = useState(false);

  const handleNavClick = () => {
    setToggleNavbar((prev) => !prev);
  };

  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-navbar text-gray-300">
      <img src={Logo} alt="Logo" style={{ width: "4.5rem" }} />
      {/* menu */}
      <ul className="hidden md:flex">
        <NavbarList sectionName="home" />
        <NavbarList sectionName="about" />
        <NavbarList sectionName="skills" />
        <NavbarList sectionName="work" />
        <NavbarList sectionName="contact" />
      </ul>

      {/* hamburger menu */}
      <div
        className="md:hidden z-10 cursor-pointer"
        onClick={() => handleNavClick()}
      >
        {!toggleNavbar ? (
          <span className="material-symbols-outlined">menu</span>
        ) : (
          <span className="material-symbols-outlined">close</span>
        )}
      </div>
      {/* mobile menu */}
      <ul
        className={
          !toggleNavbar
            ? "hidden"
            : "absolute top-0 left-0 w-full h-screen bg-navbar flex flex-col justify-center items-center"
        }
      >
        <NavbarListMobile sectionName="home" handleClick={handleNavClick} />
        <NavbarListMobile sectionName="about" handleClick={handleNavClick} />
        <NavbarListMobile sectionName="skills" handleClick={handleNavClick} />
        <NavbarListMobile sectionName="work" handleClick={handleNavClick} />
        <NavbarListMobile sectionName="contact" handleClick={handleNavClick} />
        <div className="flex mt-[1.5rem]">
          <li className="mr-[10px] flex justify-between items-center bg-blue-600">
            <a
              className="w-[15px] h-[36px] flex justify-between items-center text-gray-300"
              href="https://www.linkedin.com/in/deepak-1373/"
            >
              <FaLinkedin size={20} />
            </a>
          </li>
          <li className="mr-[10px] flex justify-between items-center bg-github">
            <a
              className="w-[15px] h-[36px] flex justify-between items-center text-gray-300"
              href="https://github.com/Deepak-1373"
            >
              <FaGithub />
            </a>
          </li>
          <li className="mr-[10px] flex justify-between items-center bg-email">
            <a
              className="w-[15px] h-[36px] flex justify-between items-center text-gray-300"
              href="mailto:dkamat.001@gmail.com"
            >
              <HiOutlineMail />
            </a>
          </li>
          <li className="mr-[10px] flex justify-between items-center bg-resume">
            <a
              className="w-[15px] h-[36px] flex justify-between items-center text-gray-300"
              href="https://docs.google.com/document/d/1vRjT55gzO9AfcrATysHiBM79VJtXPyhZpIgtNcvxnKk/edit?usp=sharing"
            >
              <BsFillPersonLinesFill />
            </a>
          </li>
        </div>
      </ul>
      {/* social icons */}
      <div className="hidden lg:flex fixed flex-col top-[35%] left-0">
        <ul>
          <NavbarSocialComponent
            bgicon="bg-blue-600"
            link="https://www.linkedin.com/in/deepak-1373/"
            iconName="Linkedin"
            icon={<FaLinkedin size={30} />}
          />
          <NavbarSocialComponent
            bgicon="bg-github"
            link="https://github.com/Deepak-1373"
            iconName="Github"
            icon={<FaGithub size={30} />}
          />
          <NavbarSocialComponent
            bgicon="bg-email"
            link="mailto:dkamat.001@gmail.com"
            iconName="Email"
            icon={<HiOutlineMail size={30} />}
          />
          <NavbarSocialComponent
            bgicon="bg-resume"
            link="https://docs.google.com/document/d/1vRjT55gzO9AfcrATysHiBM79VJtXPyhZpIgtNcvxnKk/edit?usp=sharing"
            iconName="Resume"
            icon={<BsFillPersonLinesFill size={30} />}
          />
        </ul>
      </div>
    </div>
  );
};
